import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Sprout, ArrowRight } from "lucide-react";

export default function Register() {
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", mobile: "", password: "", company_name: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await api.post("/auth/register", form);
      nav("/pending-approval");
    } catch (e2) {
      setErr(formatApiError(e2));
    } finally {
      setLoading(false);
    }
  };

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  return (
    <div className="min-h-screen bg-[#F9F8F6] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md bg-white border border-[#E5E2DC] p-8 md:p-10">
        <Link to="/" className="flex items-center gap-3 mb-8">
          <img src="/images/anuttara_logo.jpg" alt="Anuttara" className="h-11 w-11 object-cover rounded-sm" />
          <div className="font-heading font-semibold">Anuttara</div>
        </Link>
        <h1 className="font-heading text-3xl">Channel Partner Registration</h1>
        <p className="text-sm text-[#5C6653] mt-2">Register once — an admin will approve your account before you can log in.</p>

        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="register-form">
          <div>
            <Label>Full Name</Label>
            <Input required data-testid="register-name-input" value={form.name} onChange={update("name")} className="mt-1.5 rounded-sm" />
          </div>
          <div>
            <Label>Email</Label>
            <Input required type="email" data-testid="register-email-input" value={form.email} onChange={update("email")} className="mt-1.5 rounded-sm" />
          </div>
          <div>
            <Label>Mobile</Label>
            <Input required data-testid="register-mobile-input" value={form.mobile} onChange={update("mobile")} className="mt-1.5 rounded-sm" />
          </div>
          <div>
            <Label>Company (optional)</Label>
            <Input data-testid="register-company-input" value={form.company_name} onChange={update("company_name")} className="mt-1.5 rounded-sm" />
          </div>
          <div>
            <Label>Password</Label>
            <Input required type="password" data-testid="register-password-input" value={form.password} onChange={update("password")} className="mt-1.5 rounded-sm" />
          </div>
          {err && <div data-testid="register-error" className="text-sm text-red-700 bg-red-50 border border-red-200 px-3 py-2">{err}</div>}
          <Button type="submit" disabled={loading} data-testid="register-submit-button" className="w-full rounded-sm bg-[#234B36] hover:bg-[#1A3A29] text-white h-11">
            {loading ? "Submitting…" : (<>Submit for approval <ArrowRight className="h-4 w-4 ml-2" /></>)}
          </Button>
        </form>
        <div className="mt-6 text-sm text-[#5C6653]">
          Already have an account?{" "}
          <Link to="/login" data-testid="register-goto-login" className="text-[#234B36] underline underline-offset-4">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
